import { render, staticRenderFns } from "./recordList.vue?vue&type=template&id=276db7e8&scoped=true"
import script from "./recordList.vue?vue&type=script&lang=js"
export * from "./recordList.vue?vue&type=script&lang=js"
import style0 from "./recordList.vue?vue&type=style&index=0&id=276db7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276db7e8",
  null
  
)

export default component.exports